import { z } from 'zod/v4';
import { BankAccountZodSchema, Currency, Entity, } from '../../index.js';
import { queryJSONSchema } from '../../util/validation/index.js';
export var PayoutState;
(function (PayoutState) {
    PayoutState["Created"] = "CREATED";
    PayoutState["Initiated"] = "INITIATED";
    PayoutState["Completed"] = "COMPLETED";
    PayoutState["Failed"] = "FAILED";
    PayoutState["DataUpdated"] = "DATA_UPDATED";
})(PayoutState || (PayoutState = {}));
export const validNextStates = (state) => {
    switch (state) {
        case PayoutState.Created: {
            return [
                PayoutState.Initiated,
                PayoutState.DataUpdated,
                PayoutState.Completed,
            ];
        }
        case PayoutState.Initiated: {
            return [PayoutState.Completed, PayoutState.Failed];
        }
        case PayoutState.Completed: {
            return [];
        }
        case PayoutState.Failed: {
            return [PayoutState.DataUpdated];
        }
        case PayoutState.DataUpdated: {
            return [
                PayoutState.Initiated,
                PayoutState.DataUpdated,
                PayoutState.Completed,
            ];
        }
    }
};
export var PayoutType;
(function (PayoutType) {
    PayoutType["Overpayment"] = "OVERPAYMENT";
    PayoutType["CreditorReceivables"] = "CREDITOR_RECEIVABLES";
    PayoutType["CourtFee"] = "COURT_FEE";
    PayoutType["Other"] = "OTHER";
})(PayoutType || (PayoutType = {}));
export const CreatePayoutSchema = z.object({
    type: z.enum(PayoutType),
    referenceType: z.enum(Entity),
    referenceId: z.uuid(),
    account: BankAccountZodSchema,
    recipientText: z.string(),
    amount: z.number().int(),
    currency: z.enum(Currency),
    state: z.enum(PayoutState),
    details: z.any().optional(),
    caseId: z.uuid().optional(),
    caseSequentialId: z.number().int().optional(),
});
export const UpdatePayoutSchema = z.union([
    z.object({
        state: z.enum(PayoutState),
    }),
    z.object({
        account: BankAccountZodSchema.optional(),
    }),
]);
export const PayoutFilterSchema = z.object({
    fromCreatedAt: z.iso.datetime({ offset: true }).optional(),
    toCreatedAt: z.iso.datetime({ offset: true }).optional(),
    fromUpdatedAt: z.iso.datetime({ offset: true }).optional(),
    toUpdatedAt: z.iso.datetime({ offset: true }).optional(),
    fromAmount: z.coerce.number().int().optional(),
    toAmount: z.coerce.number().int().optional(),
    types: queryJSONSchema(z.array(z.enum(PayoutType)), `types need to be a valid list of types (${Object.values(PayoutType)})`).optional(),
    states: queryJSONSchema(z.array(z.enum(PayoutState)), `states need to be a valid list of states (${Object.values(PayoutState)})`).optional(),
    sortKey: z
        .enum([
        'type',
        'recipientText',
        'state',
        'amount',
        'currency',
        'updatedAt',
        'createdAt',
    ])
        .optional(),
    sortDirection: z.enum(['ASC', 'DESC']).optional(),
});
//# sourceMappingURL=index.js.map